import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleFinalsGuestNamesFormComponent } from '@app/sales/sales/sale-finals-guest-names-form/sale-finals-guest-names-form.component';

@Injectable({
  providedIn: 'root',
})
export class SaleFinalsGuestNamesFormService {
  constructor(private modalService: NgbModal) {}

  public open(saleId: number, finalId: number): Promise<any> {
    const modal = this.modalService.open(SaleFinalsGuestNamesFormComponent, {
      size: 'full' as 'lg',
    });
    modal.componentInstance.saleId = saleId;
    modal.componentInstance.finalId = finalId;
    return modal.result;
  }
}
